import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

const NotFound = () => {
  const { t } = useApp();
  return (
    <main data-testid="not-found-page" className="bg-[#0A0E1A] min-h-screen flex items-center pt-20">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <p className="font-display italic text-[#C9A84C] text-7xl">404</p>
        <h1 className="font-display text-3xl lg:text-5xl text-[#F5F0E8] mt-6">
          {t("not_found_title")}
        </h1>
        <p className="mt-5 text-[#A0A5B5] font-light">{t("not_found_sub")}</p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="btn-gold inline-block mt-10 px-8 py-4 text-xs tracking-[0.22em] uppercase font-medium"
        >
          {t("not_found_cta")}
        </Link>
      </div>
    </main>
  );
};

export default NotFound;